import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { Theme } from "@mui/material/styles";

export const EmptyInventoryWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  padding: "40px 24px 80px",
}));

export const EmptyInventoryImg = styled("img")(() => ({
  width: 450,
  marginBottom: "32px",
}));

export const EmptyInventoryText = styled("span")(() => ({
  color: "#475467",
  font: "500 24px Manrope",
}));

const styles = (viewMode: boolean) =>
  makeStyles<Theme>((theme) => ({
    mainGrid: {
      marginTop: "15px",
      display: "flex",
      flexDirection: "row",
      [theme.breakpoints.down("lg")]: {
        flexDirection: "column",
      },
      marginBottom: "10px",
    },
    heightWithInfoSection: {
      minHeight: viewMode ? "" : "445px",
    },
    heightWithoutInfoSection: {
      minHeight: viewMode ? "" : "605px",
    },
    info: {
      width: "100%",
    },
    tabs: {
      width: "35%",
      [theme.breakpoints.down("lg")]: {
        width: "100%",
      },
    },
    box: {
      marginTop: "15px",
      borderRadius: "12px",
    },
    separator: {
      margin: "0 15px",
      width: "2px",
      backgroundColor: "#ccdeee",
      [theme.breakpoints.down("lg")]: {
        display: "none",
      },
    },
  }));

export default styles;
